import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Mumbaiairporttovadodaracab() {



    const cardData = {

keyword: "Mumbai Airport to Vadodara Cab",

headingDescription:
    "Mumbai Airport Cab offers reliable and affordable Mumbai Airport to Vadodara Cab services for one-way trips, round trips, business travel, family tours, and long-distance intercity journeys. We provide a wide range of well-maintained vehicles including Sedan, SUV, Innova Crysta, Ertiga, Kia Carens, Tempo Traveller, Luxury Urbania, and Mini Bus with professional and experienced chauffeurs. With 24x7 availability, real-time flight tracking, transparent pricing, doorstep pickup from Mumbai Airport, and safe highway driving across Maharashtra and Gujarat routes, we ensure a smooth, comfortable, and hassle-free travel experience to Vadodara.",

topPlaces: [
    {
        title: "Laxmi Vilas Palace",
        description:
            "Laxmi Vilas Palace is one of the grandest royal palaces in India, known for its stunning architecture, museum, and historical significance of the Gaekwad dynasty in Vadodara."
    },
    {
        title: "Sayaji Garden (Kamati Baug)",
        description:
            "Sayaji Garden is a large and beautiful public garden featuring museums, a zoo, a planetarium, and recreational spaces, making it a popular family attraction in Vadodara."
    },
    {
        title: "EME Temple",
        description:
            "EME Temple is a unique modern temple dedicated to Lord Shiva, known for its futuristic architecture and peaceful environment maintained by the Indian Army."
    },
    {
        title: "Sursagar Lake",
        description:
            "Sursagar Lake is a scenic water body in the heart of Vadodara city, popular for evening views, lighting displays, and relaxation spots."
    },
    {
        title: "Champaner-Pavagadh Archaeological Park",
        description:
            "A UNESCO World Heritage Site near Vadodara, Champaner-Pavagadh is famous for its historical forts, mosques, temples, and ancient architecture."
    },
    {
        title: "Kirti Mandir",
        description:
            "Kirti Mandir is a memorial dedicated to the Gaekwad royal family, known for its artistic murals and cultural heritage value in Vadodara."
    },
    {
        title: "Ajwa Water Park & Dam",
        description:
            "Ajwa Dam and surrounding gardens offer a peaceful picnic spot with water views, fountains, and family-friendly recreation areas."
    },
    {
        title: "Fatehgunj & Alkapuri Area",
        description:
            "Fatehgunj and Alkapuri are major commercial and lifestyle hubs in Vadodara known for shopping, restaurants, and business activity."
    },
    {
        title: "EME Military Campus",
        description:
            "The EME campus is known for its greenery, discipline, and the iconic EME temple, reflecting Vadodara’s military and cultural balance."
    },
    {
        title: "Makarpura Palace Area",
        description:
            "Makarpura Palace is a historical royal residence now used for training purposes, showcasing Indo-Saracenic architecture and heritage importance."
    }
],



services: [
{
name: "Mumbai Airport to Vadodara Cab",
description: "Mumbai Airport Cab offers Mumbai Airport to Vadodara Cab service for safe, comfortable, and reliable long-distance airport transfer between Maharashtra and Gujarat. Whether you are arriving at Mumbai Airport for business travel, family visit, tourism, or relocation, we provide well-maintained vehicles including Sedan, SUV, Innova, Innova Crysta, Kia Carens, Tempo Traveller, and luxury cars. Our professional chauffeurs provide timely airport pickup, assistance with luggage, smooth highway driving, and stress-free intercity travel. With 24x7 availability, transparent pricing, and doorstep drop service in Vadodara, we ensure a seamless travel experience from airport to destination."
},
{
name: "Mumbai Airport to Vadodara Taxi",
description: "Mumbai Airport to Vadodara Taxi service by Mumbai Airport Cab provides dependable intercity airport transfers with clean, air-conditioned vehicles and experienced chauffeurs. Ideal for passengers needing direct travel from Mumbai Airport to Vadodara, we ensure punctual pickup, safe highway driving, and comfortable seating throughout the journey."
},
{
name: "Mumbai Airport to Vadodara Cab Fare",
description: "Mumbai Airport to Vadodara Cab Fare with Mumbai Airport Cab is transparent, competitive, and based on vehicle type, distance, and travel requirements. We offer clear pricing with no hidden charges and flexible one-way or round-trip options, ensuring affordable and reliable airport transfer service."
},
{
name: "Mumbai Airport Transfer Vadodara Cab",
description: "Mumbai Airport Transfer Vadodara Cab service provides smooth and reliable airport-to-city transportation. Mumbai Airport Cab ensures timely pickup from airport terminals, professional drivers, and comfortable vehicles for stress-free long-distance transfer to Vadodara."
},
{
name: "Mumbai Airport to Vadodara Car Rental",
description: "Mumbai Airport Cab offers Mumbai Airport to Vadodara Car Rental service with chauffeur-driven vehicles for long-distance airport transfers. Our fleet includes comfortable sedans and spacious SUVs ideal for business and family travel. We ensure safe driving, luggage support, and flexible travel options."
},
{
name: "Mumbai Airport to Vadodara One Way Cab",
description: "Mumbai Airport to Vadodara One Way Cab service provides cost-effective travel for passengers requiring a single journey without return charges. Mumbai Airport Cab ensures transparent pricing, comfortable vehicles, and professional chauffeurs for airport pickup and intercity drop."
},
{
name: "Mumbai Airport to Vadodara Outstation Cab",
description: "Mumbai Airport to Vadodara Outstation Cab service offers reliable long-distance travel with well-maintained vehicles and experienced drivers. Mumbai Airport Cab ensures safe highway driving, flexible schedules, and comfortable seating for a smooth intercity journey."
},
{
name: "Mumbai Airport Pickup Vadodara Cab",
description: "Mumbai Airport Pickup Vadodara Cab service ensures timely pickup from Mumbai Airport and direct drop to Vadodara. Mumbai Airport Cab provides professional chauffeurs who track flight timings, assist with luggage, and ensure smooth airport exit and travel experience."
},
{
name: "Mumbai Airport Drop Vadodara Cab",
description: "Mumbai Airport Drop Vadodara Cab service offers safe and comfortable transportation from Vadodara to Mumbai Airport. Mumbai Airport Cab ensures punctual pickup, stress-free highway travel, and timely arrival at airport terminals."
},
{
name: "Mumbai Airport to Vadodara Innova Cab",
description: "Mumbai Airport Cab offers Mumbai Airport to Vadodara Innova Cab service for families and groups needing spacious and comfortable airport transfer. Our Innova vehicles provide ample seating, luggage space, and smooth ride quality for long-distance travel."
},
{
name: "Mumbai Airport to Vadodara SUV Cab",
description: "Mumbai Airport to Vadodara SUV Cab service provides powerful and comfortable vehicles suitable for long highway airport transfers. Mumbai Airport Cab ensures safe driving, spacious interiors, and smooth journey experience for group and family travel."
},
{
name: "Mumbai Airport to Vadodara Business Cab",
description: "Mumbai Airport to Vadodara Business Cab service is designed for corporate travellers needing reliable airport transfers. Mumbai Airport Cab ensures punctual pickup, executive comfort, professional chauffeurs, and productive travel experience."
},
{
name: "Mumbai Airport to Vadodara Family Cab",
description: "Mumbai Airport to Vadodara Family Cab service provides safe and comfortable transportation for families arriving at or departing from Mumbai Airport. Mumbai Airport Cab ensures spacious vehicles, luggage-friendly travel, and stress-free long-distance journey."
},
{
name: "Mumbai Airport to Vadodara Round Trip Cab",
description: "Mumbai Airport to Vadodara Round Trip Cab service offers complete return journey solutions for airport transfers. Mumbai Airport Cab ensures flexible scheduling, professional chauffeurs, and comfortable vehicles for seamless round trip travel."
},
{
name: "Mumbai Airport to Vadodara Highway Cab",
description: "Mumbai Airport to Vadodara Highway Cab service ensures safe and efficient long-distance travel via major highway routes. Mumbai Airport Cab provides experienced drivers, optimized routes, and comfortable vehicles for smooth intercity airport transfers."
},
{
name: "Mumbai Airport to Vadodara Express Cab",
description: "Mumbai Airport to Vadodara Express Cab service provides fast and efficient transportation for urgent airport transfers. Mumbai Airport Cab ensures quick pickup, optimized routes, and professional drivers for timely arrival."
},
{
name: "Mumbai Airport to Vadodara Budget Cab",
description: "Mumbai Airport to Vadodara Budget Cab service offers economical airport transfer solutions without compromising safety or comfort. Mumbai Airport Cab ensures affordable pricing, clean vehicles, and reliable drivers for cost-effective travel."
},
{
name: "Mumbai Airport to Vadodara Travel Service",
description: "Mumbai Airport to Vadodara Travel Service provides complete airport-to-city transportation solutions for all types of travellers. Mumbai Airport Cab ensures safe, comfortable, and well-organized intercity travel with professional drivers and flexible options."
},
{
name: "Mumbai Airport to Vadodara Night Cab",
description: "Mumbai Airport to Vadodara Night Cab service provides safe overnight airport transfers for late-night or early-morning travel. Mumbai Airport Cab ensures experienced drivers, secure travel conditions, and comfortable vehicles for peaceful night journeys."
}
],

tableData: [
["Mumbai Airport to Vadodara Cab","Mumbai Airport to Vadodara Taxi"],
["Mumbai Airport to Vadodara Cab Fare","Mumbai Airport Transfer Cab Vadodara"],
["Mumbai Airport to Vadodara Car Rental","Mumbai Airport to Vadodara One Way Cab"],
["Mumbai Airport to Vadodara Outstation Cab","Mumbai Airport Pickup Vadodara Cab"],
["Mumbai Airport Drop Vadodara Cab","Mumbai Airport to Vadodara Innova Cab"],
["Mumbai Airport to Vadodara SUV Cab","Mumbai Airport to Vadodara Business Cab"],
["Mumbai Airport to Vadodara Family Cab","Mumbai Airport to Vadodara Round Trip Cab"],
["Mumbai Airport to Vadodara Highway Cab","Mumbai Airport to Vadodara Express Cab"],
["Mumbai Airport to Vadodara Budget Cab","Mumbai Airport to Vadodara Travel Service"]
],
















whychoose: [
    {
        WhyChooseheading: "Reliable Mumbai Airport to Vadodara Cab Service",
        WhyChoosedescription: "Mumbai Airport Cabs provides dependable Mumbai Airport to Vadodara Cab services for business travelers, families, tourists, students, and corporate professionals seeking comfortable interstate travel."
    },
    {
        WhyChooseheading: "Direct Airport Pickup Convenience",
        WhyChoosedescription: "Passengers arriving at Mumbai Airport can enjoy hassle-free pickup services with direct transportation to Vadodara without changing multiple travel modes."
    },
    {
        WhyChooseheading: "Perfect for Business and Corporate Travel",
        WhyChoosedescription: "Vadodara is one of Gujarat's major industrial and business centers, making our cab service ideal for executives, entrepreneurs, and corporate travelers."
    },
    {
        WhyChooseheading: "Wide Range of Vehicle Options",
        WhyChoosedescription: "Customers can choose Sedan cars, Ertiga, Innova Crysta, Kia Carens, SUVs, Tempo Travellers, Mini Buses, and premium vehicles according to passenger count and travel requirements."
    },
    {
        WhyChooseheading: "One-Way and Round Trip Booking Available",
        WhyChoosedescription: "Whether you require a one-way transfer, return journey, multi-day trip, or customized itinerary, we provide flexible booking options."
    },
    {
        WhyChooseheading: "Flight Monitoring and Timely Pickup",
        WhyChoosedescription: "Our team monitors flight schedules to ensure timely pickups even if flights are delayed, helping travelers enjoy a smooth airport transfer experience."
    },
    {
        WhyChooseheading: "Experienced Drivers for Interstate Routes",
        WhyChoosedescription: "Our professional chauffeurs are experienced in long-distance highway travel and ensure safe, comfortable, and punctual transportation."
    },
    {
        WhyChooseheading: "Ideal for Families, Professionals, and Groups",
        WhyChoosedescription: "From solo travelers and families to business teams and group travelers, we provide suitable vehicle options for every travel requirement."
    }
]
};

const faqData = [
    {
        question: "Why do travelers book Mumbai Airport to Vadodara Cabs?",
        answer: "Many travelers prefer direct road transportation from Mumbai Airport to Vadodara for convenience, comfort, business travel, family visits, and tourism."
    },
    {
        question: "Can I book a one-way cab from Mumbai Airport to Vadodara?",
        answer: "Yes, one-way cab services are available along with round-trip and customized travel packages."
    },
    {
        question: "Which vehicle is suitable for Mumbai Airport to Vadodara travel?",
        answer: "Sedan cars, Ertiga, Innova Crysta, Kia Carens, SUVs, Tempo Travellers, and Mini Buses are available according to passenger count and travel preferences."
    },
    {
        question: "Do you provide airport pickup from all terminals?",
        answer: "Yes, pickup services are available from domestic and international terminals at Mumbai Airport."
    },
    {
        question: "Can corporate travelers use this service regularly?",
        answer: "Yes, many business professionals and corporate clients use our Mumbai Airport to Vadodara Cab services for official travel."
    },
    {
        question: "Are Tempo Travellers available for group travel?",
        answer: "Yes, Tempo Travellers and Mini Buses are available for family groups, corporate teams, and tourist groups."
    },
    {
        question: "Will the driver wait if my flight is delayed?",
        answer: "Yes, flight schedules are monitored and pickup timings are adjusted according to actual flight arrivals."
    },
    {
        question: "Can multiple stops be included during the journey?",
        answer: "Yes, customers can customize their itinerary and include business locations, restaurants, sightseeing points, and personal stops."
    },
    {
        question: "Is advance booking recommended for Mumbai Airport to Vadodara travel?",
        answer: "Yes, advance booking helps secure your preferred vehicle and ensures smooth travel planning."
    },
    {
        question: "How can I book a Mumbai Airport to Vadodara Cab?",
        answer: "Bookings can be made through phone calls, WhatsApp messages, or online inquiries with Mumbai Airport Cabs."
    }
];

const testimonials = [
    {
        id: 1,
        name: "Mr. Hitesh Patel",
        feedback:
            "After landing at Mumbai Airport, our cab to Vadodara was ready on time. The vehicle was comfortable, the driver was professional, and the journey was completely stress-free.",
        rating: 5
    },
    {
        id: 2,
        name: "Mrs. Nehal Shah",
        feedback:
            "We booked an airport transfer from Mumbai to Vadodara and had an excellent experience. The cab was clean, spacious, and the entire trip was handled very professionally.",
        rating: 5
    }
];
































   const Images = [
    { place: "/images/keyword/114.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cabs" },
    { place: "/images/keyword/113.jpg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
    { place: "/images/keyword/112.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
    { place: "/images/keyword/111.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
    { place: "/images/keyword/110.jpg", text: "Mumbai Nashik Cab", link: "Mumbai-Nashik-Cab" },
    { place: "/images/keyword/109.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
    { place: "/images/keyword/108.jpg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
    { place: "/images/keyword/107.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
    { place: "/images/keyword/106.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
    { place: "/images/keyword/105.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
    { place: "/images/keyword/104.jpg", text: "Mumbai to 5 Jyotirlinga Cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
    { place: "/images/keyword/103.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
    { place: "/images/keyword/102.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
    { place: "/images/keyword/101.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
    { place: "/images/keyword/100.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
    { place: "/images/keyword/99.jpg", text: "Mumbai to Matheran Cab", link: "Mumbai-to-Matheran-Cab" },
    { place: "/images/keyword/98.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Dhule-Cab-Booking" },
    { place: "/images/keyword/97.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
    { place: "/images/keyword/96.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
    { place: "/images/keyword/95.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
    { place: "/images/keyword/94.jpg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
    { place: "/images/keyword/93.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
    { place: "/images/keyword/92.jpg", text: "Mumbai to Narmada Parikrama Cab Booking", link: "Mumbai-to-Narmada-Parikrama-Cab-Booking" },
    { place: "/images/keyword/91.jpg", text: "Mumbai to Baroda Cabs", link: "Mumbai-to-Baroda-Cabs" },
    { place: "/images/keyword/90.jpg", text: "Mumbai to Daman Taxi", link: "Mumbai-to-Daman-Taxi" },
];










const productSchema = {
"@context": "https://schema.org",
"@type": "Product",
"name": "Mumbai Airport to Vadodara Cab",
"image": "https://www.mumbaiairportcabs.com/assets/images/mumbai-airport-to-vadodara-cab.jpg",
"description": "Book Mumbai Airport to Vadodara cab service for reliable airport transfers and long-distance travel. Mumbai Airport Cabs offers comfortable outstation taxi service with professional drivers, one-way and round-trip options, and 24x7 availability for seamless pickup and drop journeys.",
"brand": {
"@type": "Brand",
"name": "Mumbai Airport Cabs"
},
"aggregateRating": {
"@type": "AggregateRating",
"bestRating": "5",
"worstRating": "1",
"ratingValue": "4.8",
"ratingCount": "5471"
},
"offers": {
"@type": "Offer",
"priceCurrency": "INR",
"price": "Starting From ₹14/Km",
"availability": "https://schema.org/InStock",
"url": "https://www.mumbaiairportcabs.com/mumbai-airport-to-vadodara-cab"
}
};








    return (
        <div>


<Helmet>
  <title>Mumbai Airport to Vadodara Cab | Airport Taxi Service | +91 9545731161</title>

<meta
 name="description"
 content="Book Mumbai Airport to Vadodara cab for airport pickup and drop service. Safe and comfortable long-distance taxi with professional drivers, one-way and outstation travel options, and 24x7 availability."
/>

<meta
 name="keywords"
 content="mumbai airport to vadodara cab, mumbai airport to vadodara taxi, mumbai airport to vadodara cab fare, airport transfer cab vadodara, mumbai airport to vadodara car rental, mumbai airport to vadodara one way cab, mumbai airport to vadodara outstation cab, mumbai airport pickup vadodara cab, mumbai airport drop vadodara cab"
/>

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>

</Helmet>







            <div
                className="breadcumb-wrapper"
                style={{
                    backgroundImage: "url('/images/breadcumb/breadcumb-bg.jpg')",
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                }}
            >
                <div className="container z-index-common">
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title">{cardData.keyword}</h1>
                    </div>
                </div>
            </div>


















            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/48.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#1A4160', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Mumbai Airport Cab: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>


                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="service-row">
                                        {/* <div className="service-icon">
                      🚗
                    </div> */}
                                        <div>
                                            <h4 className="service-title">{service.name}</h4>
                                            <p className="service-desc">{service.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title text-white">
                                    Why Choose <span>Mumbai Airport Cabs</span>
                                </h2>


                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Mumbai Airport Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title=""
                                                    subtitle=""
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+919545731161" className="pc-call">+91 9545731161</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/919545731161"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+919545731161" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@mumbaiairportcabs.com" className="pc-email">
                                            booking@mumbaiairportcabs.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-geo-alt-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Mumbai Airport Cabs</strong><br />

                                            SAWANT SADAN 05 Ramachandra cold drinks House,
                                            Near SBI Bank Nehru Road Opp Noble Medical,
                                            Vile Parle East Mumbai, 400057
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Mumbaiairporttovadodaracab;